import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Login';
import Dashboard from './pages/Dashboard';
import SelectCourse from './pages/SelectCourse';
import Timetable from './pages/Timetable';
import AcademicCalendar from './pages/AcademicCalendar';
import Feedback from './pages/Feedback';
import Tickets from './pages/Tickets';
import Profile from './pages/Profile';
import Submissions from './pages/Submissions';
import Attendance from './pages/Attendance';
import EventAttendance from './pages/EventAttendance';
import ScanAttendance from './pages/ScanAttendance';
import ScanAttendanceEntry from './pages/ScanAttendanceEntry';
import MyExam from './pages/MyExam';
import ExamPaper from './pages/ExamPaper';
import SharedCourses from './pages/SharedCourses';
import SharedCourseViewer from './pages/SharedCourseViewer';
import Contact from './pages/Contact';
import FavoriteLecturer from './pages/FavoriteLecturer';
import RedirectHandler from './components/RedirectHandler';
import UpdateToast from './components/UpdateToast';
import AuthService from './services/authService';

function ProtectedRoute({ children }) {
  const data = AuthService.getUser();
  const hasSession = !!(data && data.apiKey && data.studentId);

  if (!hasSession) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function App() {
  return (
    <BrowserRouter>
      <RedirectHandler />
      <UpdateToast />
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/app/select-course"
          element={(
            <ProtectedRoute>
              <SelectCourse />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/dashboard"
          element={(
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/submissions"
          element={(
            <ProtectedRoute>
              <Submissions />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/attendance"
          element={(
            <ProtectedRoute>
              <Attendance />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/event-attendance"
          element={(
            <ProtectedRoute>
              <EventAttendance />
            </ProtectedRoute>
          )}
        />
        {/* Not wrapped in ProtectedRoute: reached by directly scanning a QR
            code with the phone camera, not by clicking through the app --
            redirecting to /login here would be confusing if this browser/tab
            isn't the student's own logged-in MYC session. ScanAttendance
            handles the logged-out case itself with a clear message instead. */}
        <Route path="/app/scan-attendance/:token" element={<ScanAttendance />} />
        {/* The sidebar's "Scan Attendance" entry point (no token yet) -- opens
            the in-app camera scanner, which then routes into the page above
            once it reads a valid QR code. Reached via normal in-app
            navigation, so the usual login redirect is correct here. */}
        <Route
          path="/app/scan-attendance"
          element={(
            <ProtectedRoute>
              <ScanAttendanceEntry />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/timetable"
          element={(
            <ProtectedRoute>
              <Timetable />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/academic-calendar"
          element={(
            <ProtectedRoute>
              <AcademicCalendar />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/feedback"
          element={(
            <ProtectedRoute>
              <Feedback />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/chat"
          element={(
            <ProtectedRoute>
              <Tickets />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/profile"
          element={(
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/my-exam"
          element={(
            <ProtectedRoute>
              <MyExam />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/my-exam/:examId/start"
          element={(
            <ProtectedRoute>
              <ExamPaper />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/shared-courses"
          element={(
            <ProtectedRoute>
              <SharedCourses />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/shared-courses/:courseId"
          element={(
            <ProtectedRoute>
              <SharedCourseViewer />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/contact"
          element={(
            <ProtectedRoute>
              <Contact />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/app/favorite-lecturer"
          element={(
            <ProtectedRoute>
              <FavoriteLecturer />
            </ProtectedRoute>
          )}
        />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
